export const DOMAIN_CONTEXT = 'http://schema.org';
export const DOMAIN_TYPE = 'WebSite';
export const DOMAIN_NAME = 'Fiverr';
